import create from 'zustand';
import produce from 'immer';
import { devtools } from 'zustand/middleware';
import { IHotspotInfo, RequestState } from '../types/requester';
import { Screens } from '../utils/enums';
import { FeedBackInfo } from '../types/requester.d';

const store = (set): RequestState => ({
    activeScreen: Screens.HOME,
    fsns: [],
    products: [],
    requests: [],
    activeRequest: null,
    activeProduct: null,
    showActiveRequest: false,
    showActiveProduct: false,
    showFsnArInfoActions: false,
    feedback: null,
    hotspotInfo: null,
    setActiveScreen: (screen) =>
        set(
            produce((state: RequestState) => {
                state.activeScreen = screen;
            })
        ),
    setFsns: (fsns: Array<string>) =>
        set(
            produce((state: RequestState) => {
                state.fsns = fsns;
            })
        ),
    setProducts: (products) =>
        set(
            produce((state: RequestState) => {
                state.products = products;
            })
        ),
    setRequests: (requests) =>
        set(
            produce((state: RequestState) => {
                state.requests = requests;
            })
        ),
    setActiveRequest: (request) =>
        set(
            produce((state: RequestState) => {
                state.activeRequest = request;
            })
        ),
    setActiveProduct: (request) =>
        set(
            produce((state: RequestState) => {
                state.activeProduct = request;
            })
        ),
    setShowActiveRequest: (value: boolean) =>
        set(
            produce((state: RequestState) => {
                state.showActiveRequest = value;
            })
        ),
    setShowActiveProduct: (value: boolean) =>
        set(
            produce((state: RequestState) => {
                state.showActiveProduct = value;
            })
        ),
    setShowFsnArInfoActions: (value: boolean) =>
        set(
            produce((state: RequestState) => {
                state.showFsnArInfoActions = value;
            })
        ),
    setFeedback: (feedback: Array<FeedBackInfo>) =>
        set(
            produce((state: RequestState) => {
                state.feedback = feedback;
            })
        ),
    setHotspotInfo: (hotspotInfo: Array<IHotspotInfo>) =>
        set(
            produce((state: RequestState) => {
                state.hotspotInfo = hotspotInfo;
            })
        )
});

export const useRequestorStore = create<RequestState>(devtools(store));
